'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = require('./required');

var _required2 = _interopRequireDefault(_required);

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (prop) {
  var $params = { type: 'requiredIf', prop: prop };
  return (0, _withParams2.default)($params, function (value, parentVm) {
    var propVal = typeof prop === 'function' ? prop.call(this, parentVm) : parentVm[prop];
    return !propVal ? (0, _required2.default)(value) : true;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/requiredUnless.js
// module id = 837
// module chunks = 0